import { PrimaryButton, ProgressIndicator, TextField } from "@fluentui/react";
import { primaryButtonStyles, styles, textFieldStyles } from "../../common/views/DefaultStyles";
import { Utils } from "../../common/views/Utils";
import { AccountConfirmModel } from "../models/AccountTypes";
import { useResetPasswordVM } from "../viewmodels/ResetPasswordVM";

type ResetPasswordProps = {
    info: AccountConfirmModel;
}

export function ResetPasswordView({ info }: ResetPasswordProps) {
    const vm = useResetPasswordVM(info);

    //const isMobile = Utils.isMobile();
    const isMobile = window.innerWidth <= 500;
    const id = "login-form-wrapper" + (isMobile ? "-mobile" : "");
    const width12 = Utils.getColumnWidth(12);

    const newPasswordInput = () => {
        let errorMessages = vm.errorMessages as any;

        return <div className="ms-Grid-row left">
            <div className={width12}>
                <TextField
                    label="Password"
                    defaultValue={vm.form.password}
                    required
                    errorMessage={errorMessages.password}
                    onChange={(_, v) => vm.setField("password", v || "")}
                    styles={textFieldStyles}
                    type="Password"
                />
            </div>
        </div>;
    }

    const submitButton = () => {
        return <div className="pt-20">
            <PrimaryButton onClick={vm.reset} styles={primaryButtonStyles}>
                Submit
            </PrimaryButton>
        </div>;
    }

    return <div id={id} className="pv-10 ph-15" style={styles.middle}>
        <div className="login-form box">
            <div className="ms-Grid left ph-0">
                <div className={"left font-title p-15"} style={{ paddingTop: 6 }}>
                    Reset Password
                </div>

                <hr style={{ backgroundColor: "lightgray", height: 1, border: "none" }} />

                <div className="pt-10 pb-20 ph-15">
                    {newPasswordInput()}
                    {!vm.loading && submitButton()}
                    {vm.loading && <div className="pt-20">
                        <ProgressIndicator label="Submitting" description="" />
                    </div>}
                </div>
            </div>
        </div>
    </div>;
}